
 import BaiduMap from '@/components/maps/BaiduMap'
import GoogleMap from '@/components/maps/GoogleMap'

export default {
  components: {
 BaiduMap,
    GoogleMap
  },
  mounted () {
    if (this.$intercom) {
      this.$intercom.update({ hide_default_launcher: true })
    }
  },
  beforeDestroy () {
    if (this.$intercom) {
      this.$intercom.update({ hide_default_launcher: false })
    }
  }
}
